<template>
  <el-card
      shadow="never"
      style="border-radius: 4px !important; border: 1px solid #dee5ec; margin-right: 12px;"
      body-style="margin: 0px;">
    <div>
      <div
          class="flex flex-row"
          style="margin: 8px 24px 8px 8px">
        <img
            v-if="devicePicture && devicePicture.src"
            style="width: 80px; height: 80px"
            :alt="devicePicture.alt"
            :src="devicePicture.src">
        <div
            class="flex-1"
            style="margin: 8px">
          <div class="flex flex-row">
            <div
                class="item-name flex-1"
                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ title }}
            </div>
          </div>
          <div class="item-sku">
            <strong>ASIN: </strong>&nbsp;{{ sku }}
          </div>
          <div
              class="item-status"
              :class="'item-status-'+status.replaceAll(' ','-').toLowerCase()">
            {{ status }}
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import numeral from "numeral";

export default {
  name: "ReturnOrderDetailsItemView",
  props: {
    title: {
      type: String,
      default: "NA",
    },

    sku: {
      type: String,
      default: "NA",
    },
    status: {
      type: String,
      default: "Pending",
    },
    images: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    devicePicture() {
      return this.images[0];
    },
  },
};
</script>

<style>
.item-status-shipped {
  color: #178019 !important;
}

.item-status-pending {
  color: #f1670d !important;
}

.item-status-cancelled {
  color: #d4231a !important;
}

.item-status-waiting-for-updates {
  color: #4d11f1 !important;
}
</style>
